import i18n from "@/i18n";
import $ from 'jquery';
import CountryTag from "@/components/countryTag/CountryTag.vue"

export default {
    name: "Card",
    props: {
        title: { type: String },
        subtitle: { type: String },
        geography: { type: Array },
        heroImage: { type: String },
        sizeBig: { type: Boolean, default: null},
        subtitleOverlay: { type: String, default: "" },
        projectId: null
    },
    data() {
      return { }
    },
    mounted() {
    },
    computed: {

    },
    created: function() {
        $(document).ready(function(){
            $(".card-element .card-overlay, .card-element .card-body").hover(function(){
                $(this).parents(".card-element").find(".card-container").addClass("active");
            }, function(){
                $(this).parents(".card-element").find(".card-container").removeClass("active");
            })
        })
    },
    components: {
        CountryTag
    },
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }

};
